module.exports = __webpack_public_path__ + "img/materials_bg.3899ec1e.jpg";